import React, { useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import CaseComponent from "./case-component";
import { checkGameStatus } from "../../service/logic";
import { GAME_STAGE } from "../../utils/constant";
import { history } from "../../index";
import { GeneralHeader } from "../common";
import { store } from "../../redux/store";
import { showModal } from "../../redux/dispatchers";
import { SubheaderComponent, useWindowDimensions } from "../common";
import { Typography } from "@material-ui/core";
import leaderboard from "../../images/leaderboard_icon.png";
import tick from "../../images/tick_icon.png";
import sort from "../../images/sort_icon.png";
import { useSelector } from "react-redux";
import { getOptions } from "../../service/api/option";
import "../common/hidescrollbar.css";
import Grid from "@material-ui/core/Grid";
import { queryList } from "../../service/api/common";

const useStyles = makeStyles((theme) => ({
  canvas: {
    textAlign: "center",
    width: "100%",
    marginLeft: 0,
    marginTop: 1,
    marginBottom: 15,
    [theme.breakpoints.down("xs")]: {
      marginBottom: 30,
    },
  },
  background: {
    marginLeft: 0,
    width: "100%",
    zIndex: -1,
    backgroundColor: "#E5E5E5",
    marginTop: 0,
  },
  bg: {
    height: "100vh",
    width: "100vw",
    paddingTop: 120,
    position: "fixed",
    backgroundColor: "#E5E5E5",
    zIndex: -2,
  },
  blockDiv: {
    justifyContent: "center",
    display: "flex",
  },
  blockButton: {
    color: "white",
    background: "red",
    fontWeight: "bold",
    paddingLeft: 20,
    paddingRight: 20,
  },
  text: {
    fontSize: 18,
    [theme.breakpoints.down("sm")]: {
      fontSize: 13,
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: 10,
    },
  },
  smallText: {
    fontSize: 13,
    textAlign: "start",
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      fontSize: 11,
      maxHeight: 35,
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: 10,
      maxHeight: 28,
    },
  },
}));

function CasesPage() {
  const classes = useStyles();
  const [cases, setCases] = useState([]);
  const [sortType, setSortType] = useState({
    id: "name",
    name: "Patient Name",
  });
  const [openSort, setOpenSort] = useState(false);
  const sortList = [
    {
      id: "name",
      name: "Patient Name",
    },
    {
      id: "setting",
      name: "Setting",
    },
    {
      id: "age",
      name: "Age",
    },
  ];
  const [openBlock, setOpenBlock] = useState(false);
  const [block, setBlock] = useState({});
  const [blockList, setBlockList] = useState([]);
  const selectedStage = useSelector((state) => state.gameStates.selectedStage);
  const blockNameSeparation = !block.name ? [] : block.name.split(": ");

  useEffect(() => {
    // check if user is allowed to enter presentation page
    if (!checkGameStatus(GAME_STAGE.NOTHING)) {
      const { status } = store.getState().gameStates;
      // if not allowed, navigate to case list page
      if (status === 1) history.push("/presentation");
      else history.push("/game");
    }

    // check and navigate the select stage page if no stage is selected
    if (!selectedStage.id) {
      history.push("/");
    }

    //get selected block from select stage
    const { selectedBlock } = store.getState().gameStates;

    // get block / posting options
    getOptions("blockPosting", selectedStage.id).then((data) => {
      let tempBlockList = data.slice().sort((a, b) => {
        let firstBlockNum = parseInt(a.id.match(/\d+/)),
          secondBlockNum = parseInt(b.id.match(/\d+/));
        if (firstBlockNum < secondBlockNum) return -1;
        if (firstBlockNum > secondBlockNum) return 1;
        return 0;
      });
      setBlockList(tempBlockList);
      if (selectedBlock === "") {
        setBlock(tempBlockList[0]);
      } else setBlock(selectedBlock);
    });
  }, [selectedStage]);

  // on load get cases
  useEffect(() => {
    if (!block || !block.id) {
      setCases([]);
      return;
    }
    const role = store.getState().authDetails.role;
    // get cases by the selected stage
    let queryUrl = `query=status:active$blockId:${block.id}$order:${sortType.id}1`;
    if (role !== "student")
      queryUrl = `query=status:draft,active$blockId:${block.id}$order:${sortType.id}1`;
    queryList("kases", queryUrl).then(({ data }) => {
      setCases(data);
    });
  }, [block, sortType]);

  const navigateMenu = () => {
    showModal(
      "Back to Stage Selection",
      "Are you sure you want go back to stage selection?",
      "Confirm",
      "Cancel",
      () => {
        history.push("/");
      }
    );
  };

  const navigateLeaderboard = () => {
    history.push("/leaderboard");
  };
  const { width } = useWindowDimensions();

  const selectBlock = (block) => {
    setBlock(block);
    //to retain the block when refreshing window setGameBlock(block);
  };

  const subHeaderTab1 = {
    collapse: true,
    img: { src: tick, alt: "Stage" },
    text: (
      <>
        <Typography className={classes.text}>
          {selectedStage.name.toUpperCase()}
        </Typography>
        {width <= 600 ? (
          <Typography className={`hideScrollbar ${classes.smallText}`}>
            {blockNameSeparation[0]}
          </Typography>
        ) : (
          <Typography className={`hideScrollbar ${classes.smallText}`}>
            Block/Posting: {blockNameSeparation[0]}
          </Typography>
        )}
      </>
    ),
    list: blockList,
    onClick: selectBlock,
    open: openBlock,
    setOpen: setOpenBlock,
  };

  const subHeaderTab2 = {
    collapse: false,
    img: { src: leaderboard, alt: "Leaderboard" },
    text: <Typography className={classes.text}>LEADERBOARD</Typography>,
    onClick: navigateLeaderboard,
  };

  const subHeaderTab3 = {
    collapse: true,
    img: { src: sort, alt: "Sort" },
    text: (
      <>
        <Typography className={classes.text}>SORT BY</Typography>
        <Typography className={classes.smallText}>{sortType.name}</Typography>
      </>
    ),
    list: sortList,
    onClick: setSortType,
    open: openSort,
    setOpen: setOpenSort,
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.background}>
        <GeneralHeader backArrow profile navigate={navigateMenu} />
        <SubheaderComponent
          props={[subHeaderTab1, subHeaderTab2, subHeaderTab3]}
        />
        <div className={classes.bg} />
        <Grid
          container
          justify="center"
          spacing={5}
          className={classes.canvas}
          id={"canvas"}
        >
          {cases.map((c) => (
            <CaseComponent kase={c} key={c.id} />
          ))}
        </Grid>
      </div>
    </React.Fragment>
  );
}

export default CasesPage;
